'use client'

import { createContext, use } from 'react'

import { type TabsListVariant } from '~/components/component-library/Tabs/types'

export const TabsListVariantContext = createContext<TabsListVariant>('default')

export const useTabsListVariant = () => use(TabsListVariantContext)
